import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { COMMISSION_APPLICATIONS_URL } from 'SharedDir/backend/endpoints/commissions';
import {
  CommissionsApplicationBare,
  CommissionsApplicationCreate,
  CommissionsApplicationFull,
  CommissionsApplicationUpdate,
} from 'SharedDir/declarations/commissions';

export default class CommissionApplicationsApiClass extends SimpleApi<
  CommissionsApplicationFull,
  CommissionsApplicationCreate,
  CommissionsApplicationUpdate,
  CommissionsApplicationBare
> {
  constructor() {
    super(COMMISSION_APPLICATIONS_URL);
  }
}
